import { apiClient } from "./apiClient";

/**
 * `voiceCommandUsage` calls a real endpoint (GET /management/analytics/mobile/
 * voice-commands, api/functions/admin.py) aggregating app.VoiceCommandLogs
 * (V014) by interpreted_action.
 *
 * Everything else below is still GAP -- no backing table or telemetry
 * pipeline at all:
 *   - versionAdoption / crashRates: mobile has no crash reporting SDK wired
 *     up (no Sentry/App Center/Crashlytics in mobile/package.json) and no
 *     backend table to receive crash reports even if it did
 *   - offlineSyncSuccessRates: syncEngine.js (mobile) doesn't currently
 *     report its own success/failure counts back to the server anywhere
 *   - pushDeliveryRates: FCM delivery receipts aren't captured server-side
 *     (api/functions/notifications.py's register-device endpoint stores
 *     tokens, per the V026 gap-closure pass, but nothing tracks whether a
 *     given push was actually delivered/opened)
 *   - watchAppUsage: moot until a watch companion app exists at all (flagged
 *     as not RN-feasible during the mobile build)
 *   - biometricAuthUsage: mobile's biometricService.js never reports
 *     whether biometric unlock succeeded/was used back to the server
 */
export const mobileAnalyticsApi = {
  voiceCommandUsage: () => apiClient.get("/management/analytics/mobile/voice-commands").then((r) => r.data),
  versionAdoption: () => apiClient.get("/management/analytics/mobile/version-adoption").then((r) => r.data),
  crashRates: () => apiClient.get("/management/analytics/mobile/crash-rates").then((r) => r.data),
  offlineSyncSuccessRates: () => apiClient.get("/management/analytics/mobile/sync-success").then((r) => r.data),
  pushDeliveryRates: () => apiClient.get("/management/analytics/mobile/push-delivery").then((r) => r.data),
  watchAppUsage: () => apiClient.get("/management/analytics/mobile/watch-usage").then((r) => r.data),
  biometricAuthUsage: () => apiClient.get("/management/analytics/mobile/biometric-usage").then((r) => r.data),
};
